import React, { FC } from 'react';
import { usePlayer } from 'providers/player/PlayerContext';
import {
    isCatchupPlayerAsset,
    isLivePlayerAsset,
    isRecordingPlayerAsset,
    isTrailerPlayerAsset,
    isVodPlayerAsset,
} from 'utils/fnTypeGuards';
import { PropTypesAdditional, PropTypesPlayerUICommon } from 'types/Player';
import { useLivePlayerUI } from 'hooks/usePlayerUI/useLivePlayerUI';
import { useCatchupPlayerUI } from 'hooks/usePlayerUI/useCatchupPlayerUI';
import { useRecordingPlayerUI } from 'hooks/usePlayerUI/useRecordingPlayerUI';
import { useTrailerPlayerUI } from 'hooks/usePlayerUI/useTrailerPlayerUI';
import { useVODPlayerUI } from 'hooks/usePlayerUI/useVODPlayerUI';
import { PlayerUI } from './PlayerUI';

export const PlayerUISelector: FC<PropTypesPlayerUICommon> = (props) => {
    const { asset } = usePlayer();

    const livePlayerProps = useLivePlayerUI(props, asset);
    const catchupPlayerProps = useCatchupPlayerUI(props, asset);
    const recordingPlayerProps = useRecordingPlayerUI(props, asset);
    const trailerPlayerProps = useTrailerPlayerUI(props, asset);
    const vodPlayerProps = useVODPlayerUI(props, asset);

    const getProps = (): PropTypesAdditional => {
        if (isLivePlayerAsset(asset)) {
            return livePlayerProps;
        }

        if (isCatchupPlayerAsset(asset)) {
            return catchupPlayerProps;
        }

        if (isRecordingPlayerAsset(asset)) {
            return recordingPlayerProps;
        }

        if (isTrailerPlayerAsset(asset)) {
            return trailerPlayerProps;
        }

        if (isVodPlayerAsset(asset)) {
            return vodPlayerProps;
        }

        return {
            logo: null,
            logicalChannelNumber: null,
            metaData: [],
            contentMarker: null,
            metaIcons: [],
            controls: [],
            disabledControls: [],
            seekEnabled: false,
            title: null,
            subtitle: null,
            moreOverlayMetaData: null,
            description: null,
            cast: null,
            originalLanguages: null,
            captionLanguages: null,
        };
    };

    return (
        <PlayerUI
            {...{
                ...props,
                ...getProps(),
            }}
        />
    );
};
